import { render, staticRenderFns } from "./recycleMsgDialog.vue?vue&type=template&id=ed35ca2a&scoped=true"
import script from "./recycleMsgDialog.vue?vue&type=script&lang=js"
export * from "./recycleMsgDialog.vue?vue&type=script&lang=js"
import style0 from "./recycleMsgDialog.vue?vue&type=style&index=0&id=ed35ca2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed35ca2a",
  null
  
)

export default component.exports